/**
 * @enum MaskSortField
 * @description The fields that can be used to sort masks.
 * @property {string} id - The id of the mask.
 * @property {string} title - The title of the mask.
 * @property {string} subTitle - The sub category of the mask.
 * @property {string} status - The status of the mask.
 * @property {string} createdAt - The creation date of the mask.
 * @property {string} updatedAt - The last update date of the mask.
 */
export enum MaskSortField {
  id = 'id',
  title = 'title',
  subTitle = 'subTitle',
  status = 'status',
  createdAt = 'createdAt',
  updatedAt = 'updatedAt',
}

/**
 * Enum for required actions for a mask.
 * @enum {string}
 * @property {string} PHOTO - Photo is required.
 * @property {string} VIDEO - Video is required.
 */
export enum MaskRequiredAction {
  PHOTO = 'PHOTO',
  VIDEO = 'VIDEO',
}

export enum TirePosition {
  FL = 'FL',
  FR = 'FR',
  RL = 'RL',
  RR = 'RR',
}

/**
 * Enum for mask scope types.
 * @enum {string}
 * @property {string} ALL - All masks.
 * @property {string} COMPANY - Masks scoped to a company.
 * @property {string} TEMPLATE - Masks scoped to a template.
 * @property {string} LOCATION - Masks scoped to a location.
 */
export enum MaskScope {
  ALL = 'all',
  COMPANY = 'company',
  TEMPLATE = 'template',
  LOCATION = 'location',
}

/**
 * Enum for Type of Mask for all car types
 * @readonly TypeMask
 * @enum {string} TypeMask
 */
export enum TypeMask {
  EXTERIOR_360_VIDEO = 'EXTERIOR_360_VIDEO',
  EXTERIOR_VIN_STICKER = 'EXTERIOR_VIN_STICKER',
  INTERIOR_FUEL_LEVEL = 'INTERIOR_FUEL_LEVEL',
  EXTERIOR_TIRE_LABEL = 'EXTERIOR_TIRE_LABEL',
  WHEEL_LEFT_REAR_WHEEL = 'WHEEL_LEFT_REAR_WHEEL',
  WHEEL_RIGHT_REAR_WHEEL = 'WHEEL_RIGHT_REAR_WHEEL',
  WHEEL_RIGHT_FRONT_WHEEL = 'WHEEL_RIGHT_FRONT_WHEEL',
  WHEEL_LEFT_FRONT_WHEEL = 'WHEEL_LEFT_FRONT_WHEEL',
  WHEEL_LEFT_FRONT_TIRE_TREAD = 'WHEEL_LEFT_FRONT_TIRE_TREAD',
  WHEEL_LEFT_FRONT_TIRE_TREAD_ANGLE = 'WHEEL_LEFT_FRONT_TIRE_TREAD_ANGLE',
  WHEEL_RIGHT_FRONT_TIRE_TREAD = 'WHEEL_RIGHT_FRONT_TIRE_TREAD',
  WHEEL_RIGHT_FRONT_TIRE_TREAD_ANGLE = 'WHEEL_RIGHT_FRONT_TIRE_TREAD_ANGLE',
  WHEEL_LEFT_REAR_TIRE_TREAD = 'WHEEL_LEFT_REAR_TIRE_TREAD',
  WHEEL_LEFT_REAR_TIRE_TREAD_ANGLE = 'WHEEL_LEFT_REAR_TIRE_TREAD_ANGLE',
  WHEEL_RIGHT_REAR_TIRE_TREAD = 'WHEEL_RIGHT_REAR_TIRE_TREAD',
  WHEEL_RIGHT_REAR_TIRE_TREAD_ANGLE = 'WHEEL_RIGHT_REAR_TIRE_TREAD_ANGLE',
  INTERIOR_KEYS_FOBS = 'INTERIOR_KEYS_FOBS',

  // EXTERIOR_VIN_WINDSHIELD = 'EXTERIOR_VIN_WINDSHIELD',
  EXTERIOR_FRONT_BUMPER = 'EXTERIOR_FRONT_BUMPER',
  EXTERIOR_REAR_BUMPER = 'EXTERIOR_REAR_BUMPER',
  EXTERIOR_HOOD_WINDSHIELD = 'EXTERIOR_HOOD_WINDSHIELD',
  // EXTERIOR_HOOD_INSULATION = 'EXTERIOR_HOOD_INSULATION',
  EXTERIOR_LEFT_REAR_CORNER = 'EXTERIOR_LEFT_REAR_CORNER',
  EXTERIOR_RIGHT_REAR_CORNER = 'EXTERIOR_RIGHT_REAR_CORNER',
  EXTERIOR_RIGHT_FRONT_CORNER = 'EXTERIOR_RIGHT_FRONT_CORNER',
  EXTERIOR_LEFT_FRONT_CORNER = 'EXTERIOR_LEFT_FRONT_CORNER',
  EXTERIOR_ROOF_RIGHT_REAR_CORNER = 'EXTERIOR_ROOF_RIGHT_REAR_CORNER',
  EXTERIOR_ROOF_LEFT_FRONT_CORNER = 'EXTERIOR_ROOF_LEFT_FRONT_CORNER',
  EXTERIOR_RIGHT_SIDE_WINDSHIELD = 'EXTERIOR_RIGHT_SIDE_WINDSHIELD',
  EXTERIOR_LEFT_SIDE_WINDSHIELD = 'EXTERIOR_LEFT_SIDE_WINDSHIELD',
  EXTERIOR_LEFT_FRONT_HALF = 'EXTERIOR_LEFT_FRONT_HALF',
  EXTERIOR_LEFT_REAR_HALF = 'EXTERIOR_LEFT_REAR_HALF',
  // EXTERIOR_LEFT_FRONT_FENDER = 'EXTERIOR_LEFT_FRONT_FENDER',
  // EXTERIOR_LEFT_FRONT_DOOR = 'EXTERIOR_LEFT_FRONT_DOOR',
  // EXTERIOR_LEFT_REAR_DOOR = 'EXTERIOR_LEFT_REAR_DOOR',
  // EXTERIOR_LEFT_REAR_QUARTER = 'EXTERIOR_LEFT_REAR_QUARTER',
  // EXTERIOR_RIGHT_REAR_QUARTER = 'EXTERIOR_RIGHT_REAR_QUARTER',
  // EXTERIOR_RIGHT_REAR_DOOR = 'EXTERIOR_RIGHT_REAR_DOOR',
  // EXTERIOR_RIGHT_FRONT_DOOR = 'EXTERIOR_RIGHT_FRONT_DOOR',
  // EXTERIOR_RIGHT_FRONT_FENDER = 'EXTERIOR_RIGHT_FRONT_FENDER',
  EXTERIOR_RIGHT_REAR_HALF = 'EXTERIOR_RIGHT_REAR_HALF',
  EXTERIOR_RIGHT_FRONT_HALF = 'EXTERIOR_RIGHT_FRONT_HALF',
  EXTERIOR_LEFT_FULL_SIDE = 'EXTERIOR_LEFT_FULL_SIDE',
  EXTERIOR_RIGHT_FULL_SIDE = 'EXTERIOR_RIGHT_FULL_SIDE',
  // EXTERIOR_CHARGING_PORT_OPEN = 'EXTERIOR_CHARGING_PORT_OPEN',
  // EXTERIOR_OPEN_FRUNK = 'EXTERIOR_OPEN_FRUNK',
  // MECHANICAL_RIGHT_FRONT_APRON = 'MECHANICAL_RIGHT_FRONT_APRON',
  // MECHANICAL_LEFT_FRONT_APRON = 'MECHANICAL_LEFT_FRONT_APRON',
  // MECHANICAL_ENGINE_COMPARTMENT = 'MECHANICAL_ENGINE_COMPARTMENT',
  // MECHANICAL_LEFT_FRONT_UNDERCARRIAGE = 'MECHANICAL_LEFT_FRONT_UNDERCARRIAGE',
  // MECHANICAL_RIGHT_FRONT_UNDERCARRIAGE = 'MECHANICAL_RIGHT_FRONT_UNDERCARRIAGE',
  // MECHANICAL_LEFT_REAR_UNDERCARRIAGE = 'MECHANICAL_LEFT_REAR_UNDERCARRIAGE',
  // MECHANICAL_RIGHT_REAR_UNDERCARRIAGE = 'MECHANICAL_RIGHT_REAR_UNDERCARRIAGE',
  // MECHANICAL_FRONT_UNDERCARRIAGE = 'MECHANICAL_FRONT_UNDERCARRIAGE',
  // MECHANICAL_REAR_UNDERCARRIAGE = 'MECHANICAL_REAR_UNDERCARRIAGE',
  // MECHANICAL_DIP_STICK_OIL = 'MECHANICAL_DIP_STICK_OIL',
  INTERIOR_FRONT_SEATS_LEFT_SIDE = 'INTERIOR_FRONT_SEATS_LEFT_SIDE',
  // INTERIOR_FRONT_SEATS_RIGHT_SIDE = 'INTERIOR_FRONT_SEATS_RIGHT_SIDE',
  INTERIOR_DASH_PANEL = 'INTERIOR_DASH_PANEL',
  INTERIOR_WINDSHIELD_FROM_INSIDE = 'INTERIOR_WINDSHIELD_FROM_INSIDE',
  INTERIOR_LEFT_FRONT_DOOR_TRIM = 'INTERIOR_LEFT_FRONT_DOOR_TRIM',
  // INTERIOR_RIGHT_FRONT_DOOR_TRIM = 'INTERIOR_RIGHT_FRONT_DOOR_TRIM',
  INTERIOR_RIGHT_REAR_DOOR_TRIM = 'INTERIOR_RIGHT_REAR_DOOR_TRIM',
  // INTERIOR_LEFT_REAR_DOOR_TRIM = 'INTERIOR_LEFT_REAR_DOOR_TRIM',
  INTERIOR_TRUNK = 'INTERIOR_TRUNK',
  INTERIOR_SPARE_TIRE = 'INTERIOR_SPARE_TIRE',
  INTERIOR_REAR_SEATS_RIGHT_SIDE = 'INTERIOR_REAR_SEATS_RIGHT_SIDE',
  INTERIOR_DASHBOARD = 'INTERIOR_DASHBOARD',
  // INTERIOR_HEADLINER_BLINDERS = 'INTERIOR_HEADLINER_BLINDERS',
  // INTERIOR_RIGHT_FRONT_DOOR_HINGES = 'INTERIOR_RIGHT_FRONT_DOOR_HINGES',
  // INTERIOR_LEFT_FRONT_DOOR_HINGES = 'INTERIOR_LEFT_FRONT_DOOR_HINGES',
  // INTERIOR_RIGHT_CENTRAL_PILLAR = 'INTERIOR_RIGHT_CENTRAL_PILLAR',
  // INTERIOR_LEFT_CENTRAL_PILLAR = 'INTERIOR_LEFT_CENTRAL_PILLAR',
  // INTERIOR_RIGHT_REAR_DOOR_HINGES = 'INTERIOR_RIGHT_REAR_DOOR_HINGES',
  // INTERIOR_LEFT_REAR_DOOR_HINGES = 'INTERIOR_LEFT_REAR_DOOR_HINGES',
  INTERIOR_RIGHT_REAR_HEADLINER = 'INTERIOR_RIGHT_REAR_HEADLINER',
  // INTERIOR_RIGHT_FRONT_HEADLINER = 'INTERIOR_RIGHT_FRONT_HEADLINER',
  INTERIOR_ODOMETER_MILES = 'INTERIOR_ODOMETER_MILES',
  // INTERIOR_THIRD_ROW_SEATS_RIGHT_SIDE = 'INTERIOR_THIRD_ROW_SEATS_RIGHT_SIDE',
  // INTERIOR_THIRD_ROW_SEATS_LEFT_SIDE = 'INTERIOR_THIRD_ROW_SEATS_LEFT_SIDE',
  // INTERIOR_CHARGING_CABLE = 'INTERIOR_CHARGING_CABLE',
}

export const TIRE_GROOVE_POSITION_BY_MASK: Partial<Record<TypeMask, TirePosition>> = {
  [TypeMask.WHEEL_LEFT_FRONT_TIRE_TREAD]: TirePosition.FL,
  [TypeMask.WHEEL_LEFT_REAR_TIRE_TREAD]: TirePosition.RL,
  [TypeMask.WHEEL_RIGHT_REAR_TIRE_TREAD]: TirePosition.RR,
  [TypeMask.WHEEL_RIGHT_FRONT_TIRE_TREAD]: TirePosition.FR,
};
